export default "__VITE_ASSET__BuR67fKk__"